// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NotFound_wrap__1YpKq","image":"NotFound_image__2kohD","title":"NotFound_title__2xxzt","description":"NotFound_description__1JOhc"};